import {Component, Input, OnChanges} from '@angular/core';
import {AuditLogFilterPipe} from '../helper/audit-log-filter.pipe';
import {AuditLogVO} from '../../../generate/AuditLogVO';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';
import {AppConfigService} from '../../../services/app.config.service';

@Component({
  selector: 'audit-log-block',
  templateUrl: './audit-log-block.component.html',
  styleUrls: ['./audit-log-block.component.scss']
})
export class AuditLogBlockComponent implements OnChanges {


  options = [
    {name: 'All', value: 'all', checked: true},
    {name: 'State Change', value: 'workflow_step', checked: false},
    {name: 'Outgoing Email', value: 'authorization_sent', checked: false},
    {name: 'Incoming Email', value: 'notification_recieved', checked: false},
    {name: 'Comment', value: 'comment', checked: false},
  ];

  @Input()
  auditLog: AuditLogVO[];

  filteredAuditLog: AuditLogVO[];

  @Input()
  changeRequestVO: ChangeRequestVO;

  auditLogFilterPipe = new AuditLogFilterPipe();

  constructor(private appConfigService: AppConfigService) {
  }

  public isTldManagerInterface() {
    return this.appConfigService.isTldManagerInterface();
  }

  ngOnChanges(changes: any): void {
    this.changeFilter();
  }

  get selectedOptions() {
    return this.options
      .filter(opt => opt.checked)
      .map(opt => opt.value);
  }

  changeFilter() {
    this.filteredAuditLog = [];

    if (this.isTldManagerInterface()) {
      this.filteredAuditLog = this.auditLog;
    } else {
      if (this.selectedOptions.includes('all')) {
        this.filteredAuditLog = this.auditLog;
      } else {
        this.selectedOptions.forEach(filter => {
          if ([this.options[1].value, this.options[3].value, this.options[4].value].indexOf(filter) > -1) {
            this.filteredAuditLog = [...this.filteredAuditLog, ...this.auditLogFilterPipe.transform(this.auditLog, filter)];
          } else if (filter === this.options[2].value) {
            this.filteredAuditLog = [...this.filteredAuditLog, ...this.auditLogFilterPipe.transform(this.auditLog, 'authorization_sent'), ...this.auditLogFilterPipe.transform(this.auditLog, 'impacted_party_sent')];
          }
        });
      }
    }
    this.filteredAuditLog.sort((a, b) => <any> new Date(b.timestamp) - <any> new Date(a.timestamp));

  }
}
